import { useState } from 'react';
import { MapPin, RectangleDashed } from '@phosphor-icons/react';
import { ItemImage, SkupremeModal } from '../../components';
import { ColoredPill, HoverBorderButton, MuteText, StyledButton } from '../../elements';
import { InventoryAdjustmentTypes, InventoryService, ToastMessage } from '../../utility';

export function TransferPopup({ onClose, item, refresh, open }) {
  const [loading, setLoading] = useState(false);

  const onConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        adjustmentType: InventoryAdjustmentTypes.transfer,
        quantity: item.suggestedQuantity,
        note: 'Transfer suggested by system',
        destinationLocationId: item.destinationLocationId._id,
      };

      await InventoryService.updateInventory(item.inventoryId._id, payload);
      refresh();
      ToastMessage.success('Inventory adjusted successfully');
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal size="mini" title="Transfer Inventory" onClose={onClose} open={open}>
      <div className="d-flex align-items-center mb-3">
        <ItemImage
          imageKey="p_images"
          displayImageKey="display_image"
          item={item?.productId}
          size="mini"
        />
        <div className="d-flex ml-2">
          <MuteText>SKU</MuteText>
          <b className="ml-2">{item?.productId?.p_sku}</b>
        </div>
      </div>
      <div>
        <div className="d-flex flex-column">
          <MuteText>Lot Number</MuteText>
          <span>{item?.inventoryId?.lotNumber}</span>
        </div>
        <div className="my-3">
          <MuteText>Destination Location</MuteText>
          <div className="d-flex">
            <ColoredPill color={item?.destinationLocationId?.zoneId?.color}>
              <RectangleDashed />
              <span>{item?.destinationLocationId?.zoneId?.code}</span>
            </ColoredPill>
            <ColoredPill
              color={item?.destinationLocationId?.zoneId?.color}
              className="ml-1"
            >
              <MapPin />
              <span>{item?.destinationLocationId?.code}</span>
            </ColoredPill>
          </div>
        </div>
        <div className="d-flex flex-column">
          <MuteText>Suggested Quantity</MuteText>
          <span>{item?.suggestedQuantity}</span>
        </div>
        <div className="d-flex justify-content-end mt-4">
          <HoverBorderButton type="button" disabled={loading} onClick={onClose}>
            Cancel
          </HoverBorderButton>
          <StyledButton loading={loading} onClick={onConfirm} className="ml-2">
            Confirm
          </StyledButton>
        </div>
      </div>
    </SkupremeModal>
  );
}
